import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getLocalizedString } from "@icarius-localization/strings";
import { CloseIcon } from "@icarius-icons";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Typography,
} from "@material-ui/core";
import DialogTitleDivider from "@icarius-common/dialogTitleDivider";
import ButtonDialogAction from "@icarius-common/buttonDialogAction";
import PaperDraggable from "@icarius-common/paperDraggable";
import DialogTransition from "@icarius-common/dialogTransition";
import { massiveDivisionChangeAction } from "@icarius-pages/myPeople/actions";
import { getEditableFields } from "../../selectors";
import { MuiPickersUtilsProvider, DatePicker } from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import { dateLocale } from "@icarius-localization/strings";
import { formatDateYYYYMMDD } from "@icarius-utils/date";

const gridStyle = { height: 75, padding: "0px 10px" };

const DivisionDialog = (props) => {

  const {
    open,
    isLoading,
    employees,
    handleAfterSubmit,
    handleClose,
  } = props;

  const [division, setDivision] = useState("-");
  const [divisionAssignationDate, setDivisionAssignationDate] = useState(null);

  const editableFields = useSelector(getEditableFields);

  const divisionArray = editableFields.find(item => item.name === 'DIVISION').options
    .map((item) => ({ key: item.id, value: item.value }))
    .filter(item => item.key !== "");

  const dispatch = useDispatch();

  const handleSubmit = () => {
    dispatch(massiveDivisionChangeAction({
      codes: employees.map(item => item.code),
      divisionAssignationDate: divisionAssignationDate ? formatDateYYYYMMDD(divisionAssignationDate) : null,
      division,
    }))
      .then((resp) => {
        if (resp.status === 200) {
          handleAfterSubmit(resp?.data?.showAlert);
        }
        handleClose();
      });
  };

  if (isLoading) return null;

  return (
    <Dialog
      open={open}
      TransitionComponent={DialogTransition}
      PaperComponent={PaperDraggable}
      maxWidth={"sm"}
      fullWidth={true}
    >
      <div className={"dialog-container"}>
        <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">
          {getLocalizedString("massDivisionChanges")}
          <DialogTitleDivider />
        </DialogTitle>
        <CloseIcon className={"dialog-close-icon icon"} onClick={handleClose} />
        <DialogContent>
          <Grid container>
            <Grid container item alignItems="center" xs={12} sm={6} style={gridStyle}>
              <FormControl style={{ width: "100%" }}>
                <InputLabel id={`label-turn`}>{getLocalizedString("SHOW_DIVISION")}</InputLabel>
                <Select
                  value={division}
                  labelId={`label-turn`}
                  id={`select-turn`}
                  onChange={(e) => setDivision(e.target.value)}
                  margin={"none"}
                >
                  {
                    divisionArray.map(item => (
                      <MenuItem
                        className={"whiteText"}
                        key={item.key}
                        value={item.key}
                      >
                        {item.value}
                      </MenuItem>
                    ))
                  }
                </Select>
              </FormControl>
            </Grid>
            <Grid container item alignItems="center" xs={12} sm={6} style={gridStyle}>
              <MuiPickersUtilsProvider utils={DateFnsUtils} locale={dateLocale}>
                <DatePicker
                  fullWidth
                  label={getLocalizedString("unitAssignationDate")}
                  cancelLabel={getLocalizedString("cancel")}
                  okLabel={getLocalizedString("ok")}
                  invalidDateMessage=''
                  format="dd/MM/yyyy"
                  margin="none"
                  value={divisionAssignationDate}
                  onChange={(e) => setDivisionAssignationDate(e)}
                />
              </MuiPickersUtilsProvider>
            </Grid>
          </Grid>
          <Typography className="whiteText" style={{ margin: 10, fontWeight: 500 }}>
            {getLocalizedString("turnChangeQuestion", { length: employees.length })}
          </Typography>
        </DialogContent>
        <DialogActions>
          <ButtonDialogAction onClick={handleClose} text={getLocalizedString("disagree")} />
          <ButtonDialogAction onClick={handleSubmit} isAccept text={getLocalizedString("accept")} />
        </DialogActions>
      </div>
    </Dialog>
  );
}

export default DivisionDialog;
